// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ILDU","row":"Node_row__2FblZ","label":"Node_label__1zkAh","footer":"Node_footer__9yvec"};